<script setup>
import ToastHost from '@/components/ToastHost.vue'

/**
 * 应用根组件。
 *
 * 它只做两件事：渲染当前路由对应的组件，以及挂一个全局的轻提示宿主。
 * 页头、底部导航这些外壳属于各自的布局组件（OwnerLayout / StaffLayout），
 * 因为老板端和员工端的外壳完全不同——放在这里会变成一堆 v-if。
 *
 * 登录页则根本没有外壳，这也是外壳不能放在根组件的原因之一。
 *
 * ToastHost 反过来必须放在这里而不是 AppShell 里：提示的队列是模块级的全局单例，
 * 挂在布局里就意味着三个端各有一个宿主，而登录页、改密页没有布局、一个都没有。
 * 结果是「密码改成功了」这种提示在最需要它的页面上恰好不显示。
 */
</script>

<template>
  <RouterView v-slot="{ Component }">
    <!--
      keep-alive 暂时不加。
      它能让页面切换后保留滚动位置和已填的表单，体验更好；但也会让组件不再重新
      挂载，数据不会自动刷新——对「今天有哪些房间要扫」这种需要实时的页面反而是坑。
      等各页面的数据刷新策略定下来之后再逐个开启，不要一上来全局打开。
    -->
    <component :is="Component" />
  </RouterView>

  <ToastHost />
</template>
